import * as classNames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import * as styles from './Progressbar.css'

interface ProgressbarProps {
  max: number
  now: number
}

const Progressbar: React.FunctionComponent<ProgressbarProps> = ({ max, now }) => {
  const nowCount = now < 0 ? 0 : now
  const ratio = (nowCount / max) * 100
  let barClass = styles.warn
  if (ratio >= 50) {
    barClass = styles.normal
  } else if (ratio < 25) {
    barClass = styles.error
  }

  return (
    <div className={styles.progressbar}>
      <div className={classNames(styles.front, barClass)} style={{ width: `${ratio}%` }} />
    </div>
  )
}

export default compose<ProgressbarProps, ProgressbarProps>(pure)(Progressbar)
